// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';

// Local Constants
import { RESET_STATE } from '../auth/constants';
import { CROPSURE_PASSWORDS_SET, CROPSURE_PASSWORDS_DELETE } from './constants';

// Local Types
import { ResetStateAction } from '../auth/types';
import { CropsurePasswordsState, CropsurePasswordsActions } from './types';

const initialState: CropsurePasswordsState = {};

export default function cropsurePasswordsReducer(
    state: CropsurePasswordsState = initialState,
    action: CropsurePasswordsActions | ResetStateAction
): CropsurePasswordsState {
    switch (action.type) {
        case CROPSURE_PASSWORDS_SET:
            return {
                ...state,
                ...action.payload
            };
        case CROPSURE_PASSWORDS_DELETE: {
            const { uuids } = action.payload;
            const clonedState = { ...state };

            uuids.forEach((uuid) => delete clonedState[uuid]);

            return clonedState;
        }
        case SET_CURRENT_ORGANIZATION_ID:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
